import { MenuItemModel } from '@syncfusion/ej2-react-navigations';
import { IMappings } from './types';

export const HEADER_TYPE = {
    TYPE: 'Type',
    MANUFACTURE: 'Manufacturer',
    MODEL_NUMBER: 'Model Number',
    MANUFACTURE_MODEL_NO: 'Manufacturer & Model Number',
    SUBMITTAL_NOTES: 'Submittal Notes (external)',
    QUANTITY: 'Quantity',
    DESCRIPTION: 'Description',
    IGNORE_COLUMN: 'Ignore Column',
    QUOTE_NOTES: 'Quote Notes',
    UNIT_COST: 'Unit Cost',
    LEAD_TIME: 'Lead Time',
    EXTENDED_COST: 'Extended Cost',
    PER: "Per"
};

export const MENU_ITEMS: MenuItemModel[] = [
    {
        text: 'Type'
    },
    {
        text: 'Manufacturer'
    },
    {
        text: 'Model Number'
    },
    {
        text: 'Manufacturer & Model Number'
    },
    {
        text: 'Submittal Notes (external)'
    },
    {
        text: 'Quantity'
    },
    {
        text: 'Description'
    },
    {
        text: 'Quote Notes'
    },
    {
        text: 'Unit Cost'
    },
    {
        text: 'Lead Time'
    },
    {
        text: 'Extended Cost'
    },
    {
        text: 'Per'
    },
    {
        text: 'Ignore Column'
    }
];

export const MAPPINGS: IMappings = {
    TYPE: 'Type',
    MANUFACTURER: 'Manufacturer',
    MODEL_NUMBER: 'Model Number',
    MANUFACTURER_MODEL_NO: 'Manufacturer & Model Number',
    SUBMITTAL_NOTES: 'Submittal Notes (external)',
    QUANTITY: 'Quantity',
    DESCRIPTION: 'Description',
    QUOTE_NOTES: 'Quote Notes',
    UNIT_COST: 'Unit Cost',
    LEAD_TIME: 'Lead Time',
    EXTENDED_COST: 'Extended Cost',
    PER: 'Per'

};

export const PER_INFO_TEXT = "The 'Per' column only accepts 1 (or E), 100 (or C), 1000 (or M) as valid entries. Any invalid entries will be parsed to 1 by default."
